import { OnDestroy, Component } from '@angular/core'
import { Subscription } from 'rxjs'
import { KeyPathOrGetter } from 'nuclear-js'
import { NuclearObservable } from '../nuclear-observable'
import { customerGetters } from '../stores/customer-store'
import { userGetters } from '../stores/user-store'
import { Account, Customer, User } from '../types'

type ObserverFn<T> = (value: T) => void;

@Component({
  selector: 'base-component',
  template: '<div></div>'
})
export class BaseComponent implements OnDestroy {
  protected observers: Subscription[] = [];
  protected routeObservers: Subscription[] = [];
  protected intervals: Array<NodeJS.Timer|number> = [];

  observe(getter: KeyPathOrGetter, fn: ObserverFn<any>): void {
    this.observers.push(NuclearObservable.from<any>(getter, { toJS: true }).subscribe(fn))
  }

  observeOnRoute(getter: KeyPathOrGetter, fn: ObserverFn<any>): void {
    this.routeObservers.push(NuclearObservable.from<any>(getter, { toJS: true }).subscribe(fn))
  }

  observeAccount(fn: ObserverFn<Account>): void {
    this.observe(customerGetters.account, fn)
  }

  observeCustomers(fn: ObserverFn<Customer[]>): void {
    this.observe(customerGetters.shallowCustomers, fn)
  }

  observeCustomer(id: number, fn: ObserverFn<Customer>): void {
    this.observeOnRoute(customerGetters.customer(id), fn)
  }

  observeUser(fn: ObserverFn<User>): void {
    this.observe(userGetters.user, fn)
  }

  observeUiState(fn: ObserverFn<Object>): void {
    this.observe(userGetters.uiState, fn)
  }

  clearObservers(): void {
    this.observers.forEach((o) => {if (o) o.unsubscribe() })
    this.observers = []
  }

  clearRouteObservers(): void {
    this.routeObservers.forEach((o) => {if (o) o.unsubscribe() })
    this.routeObservers = []
  }

  clearIntervals(): void {
    this.intervals.forEach((i) => clearInterval(<number>i))
    this.intervals = []
  }

  ngOnDestroy(): void {
    this.clearRouteObservers()
    this.clearObservers()
    this.clearIntervals()
  }
}
